import { RouteLocationNormalizedLoaded } from "vue-router";

export const generateBreadCrumb = (route: RouteLocationNormalizedLoaded) => {
  const { locale } = useI18n();

  return route.fullPath.replace(`/${locale.value}/`, "").replace(/&/g, " & ").split("?")[0].split("/");
};
